"use strict";

(() => {
    const accordionButtons = document.querySelectorAll('.panel--accordion .bs-navigation-panel__list-item__button');

    if(accordionButtons.length > 0) {
        accordionButtons.forEach((accordionButton) => {
            accordionButton.addEventListener('click', (e) => {
                e.currentTarget.parentElement.classList.toggle('active');
            });
        });
    }
})();